import { getQueryStringVariable } from '../../../data/utils/getQueryStringVariable';
import { appConfig } from "../../../appConfig";

function isLegacy() {
    //appConfig.ROUTES['legacy'] = false
    const queryVal = getQueryStringVariable("legacy") || null;
    return queryVal === 'true' ? true : queryVal === 'false' ? false : (appConfig?.ROUTES?.['legacy'] || (window.injectXSport ? true : false) || false);
}

let legacyRoutes = null;
export function getLegacyRoutes() {
    if (!legacyRoutes) legacyRoutes = isLegacy();
    return legacyRoutes;
}
